import { action } from 'typesafe-actions';
import { IAuthState, Types } from './types';

export const refreshAuthTokenRequest = () =>
  action(Types.REFRESH_AUTH_TOKEN_REQUEST);

export const refreshAuthTokenSuccess = (
  azureToken: string,
  azureExpireIn: string,
  azureDateTimeExpiration: number
) =>
  action(Types.REFRESH_AUTH_TOKEN_SUCCESS, {
    azureToken,
    azureExpireIn,
    azureDateTimeExpiration
  });

export const refreshAuthTokenFailure = (error: Error) =>
  action(Types.REFRESH_AUTH_TOKEN_FAILURE, { error });

export const refreshAuthTokenFailureGeneric = () =>
  action(Types.REFRESH_AUTH_TOKEN_FAILURE, 'Unknown error occurred');

export const updateAuthStateSuccess = (
  azureToken: string,
  azureExpireIn: number,
  azureDateTimeExpiration: number
) =>
  action(Types.UPDATE_AUTH_STATE_SUCCESS, {
    azureToken,
    azureExpireIn,
    azureDateTimeExpiration
  });

export const loadAuthState = (
  azureToken: string,
  azureDateTimeExpiration: number
) =>
  action(Types.LOAD_AUTH_STATE, {
    azureToken,
    azureExpireIn: 0,
    azureDateTimeExpiration
  });

export const loadAuthStateSuccess = (authState: IAuthState) =>
  action(Types.LOAD_AUTH_STATE_SUCCESS, { authState });

export const loadAuthStateFailure = (error: unknown) =>
  action(Types.LOAD_AUTH_STATE_FAILURE, { error });
